// src/environments/index.ts
import { isDevMode } from '@angular/core';
import { environment as devEnvironment } from './environment.dev';
import { environment as prodEnvironment } from './environment.prod';

export const environment = isDevMode() ? devEnvironment : prodEnvironment;
